module.exports = __webpack_public_path__ + "static/media/5.ddac05e1.jpg";